export const BLANK_TEMPLATE_ID = 'blank';
export const BLANK_TEMPLATE_BUILD_SLUG = 'ws-intense-next-blank';
export const DEFAULT_TEMPLATE_BUILD_SLUG = 'ws-intense-next-default';
